export const homeObjOne = {
    primary: true,
    lightBg: false,
    lightTopLine: true,
    lightText: true,
    lightTextDesc: true,
    topLine: 'Protege tus datos, protege tu futuro',
    headline: 'Cursos de capacitación – ISO/IEC 27001 Information Security Management Systems',
    description:
      'En CXP NETWORKS trabajamos para garantizar un sistema gestionado donde integramos la estructura organizativa, las políticas, procesos y recursos en términos de seguridad.   ',
    buttonLabel: 'Get Started',
    imgStart: '',
    //img: require('../../images/svg-3.svg'),
    img:require('../../images/profile.jpg'),
    alt: 'Credit Card',
    start: ''
  };
  
  export const homeObjTwo = {
    primary: true,
    lightBg: false,
    lightTopLine: true,
    lightText: true,
    lightTextDesc: true,
    topLine: 'Instant Setup',
    headline: 'Extremely quick onboarding process',
    description:
      "Once you've joined, our team of specialists will reach out to you and get you set up in minutes.",
    buttonLabel: 'Learn More',
    imgStart: '',
    img: require('../../images/svg-2.svg'),
    alt: 'Vault',
    start: ''
  };
  
  export const homeObjThree = {
    primary: false,
    lightBg: true,
    lightTopLine: false,
    lightText: false,
    lightTextDesc: false,
    topLine: 'Prepárate para la Ruta',
    headline:
      'DataProtec Pro 2026',
    description:
      "Desarrolle el Capital Humano que Liderará el Futuro de su Organización en Materia de Ciberseguridad y Protección de Datos Personales \n \n"
      +"  Cumple con la Capacitación y Adiestramiento Alineado a la STPS y con la Nueva Ley de Protección  de Datos Personales 2025\n \n "
      +"TODO LO QUE NECESITAS PARA GESTIONAR LA PROTECCIÓN DE DATOS PERSONALES Y LA SEGURIDAD DIGITAL DE TU EMPRESA EN ESTE 2026 \n \n "
      +"1.-Fundamentos Esenciales de Ciberseguridad y Protección de Datos Personales para Empresas y Entidades del Sector Público. \n \n "
      +"2.-Especialista en Protección de Datos Personales.\n \n "
      +"3.-Implementación de Estrategias de Ciberseguridad Basadas en: ISO/IEC 27032:2023",
    buttonLabel: 'DataProtec',
    imgStart: 'start',
    img: require('../../images/homep1.png'),
    alt: 'DataProtec2026',
    start: 'true'
  };
  
  export const homeObjFour = {
    primary: true,
    lightBg: false,
    lightTopLine: true,
    lightText: true,
    lightTextDesc: true,
    topLine: 'Secure Database',
    headline: 'All your data is stored on our secure server',
    description:
      'You will never have to worry about your information getting leaked. Our team of security experts will ensure your records are kept safe.',
    buttonLabel: 'Sign Up Now',
    imgStart: 'start',
    img: require('../../images/svg-3.svg'),
    alt: 'Vault',
    start: 'true'
  };